import "./digital-assets-my-library-notification.scss";

export class MyLibraryNotification {
  #timeout;

  #notificationWrapperSelector = "#js-dam-library-notification";

  #activeNotificationSelector = "#js-dam-library-notification-add";

  #disableNotificationSelector = "#js-dam-library-notification-remove";

  get #$notificationWrapper() {
    return document.querySelector(this.#notificationWrapperSelector);
  }

  get #$activeNotification() {
    return document.querySelector(this.#activeNotificationSelector);
  }

  get #$disableNotification() {
    return document.querySelector(this.#disableNotificationSelector);
  }

  #visibleWrapper() {
    this.#$notificationWrapper.classList.remove("invisible");
  }

  #invisibleWrapper() {
    this.#$notificationWrapper.classList.add("invisible");
  }

  updateNotification(isActive) {
    clearTimeout(this.#timeout);

    this.#visibleWrapper();

    this.#$activeNotification.classList.toggle("hidden", !isActive);
    this.#$disableNotification.classList.toggle("hidden", isActive);

    this.#timeout = setTimeout(() => {
      this.#invisibleWrapper();
    }, 3000);
  }
}

export default () => new MyLibraryNotification();
